import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import CartsPage from "@/pages/CartsPage";
import DraftHistoryPage from "@/pages/DraftHistoryPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import SettingsPage from "@/pages/SettingsPage";
import ProfilePage from "@/pages/ProfilePage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="bottom-right"
          toastOptions={{
            classNames: {
              toast:
                "!rounded-sm !border !border-zinc-200 !bg-white !text-zinc-900 !font-medium",
              description: "!text-zinc-500 !font-mono !text-[11px]",
              actionButton: "!bg-[#002FA7] !text-white !rounded-sm",
              success: "!border-emerald-200",
              error: "!border-red-200",
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/carts" replace />} />
            <Route path="/carts" element={<CartsPage />} />
            <Route path="/history" element={<DraftHistoryPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminUsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute requireAdmin>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/carts" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
